module.exports = __webpack_public_path__ + "img/customers.5f43c811.svg";